import { Box, styled } from '@mui/material';

export default styled(Box)(({ theme }) => ({
  //
}));
